/**
 * Simple logging utilities using UI colors and symbols
 */

import { colors, symbols, formatKeyValue, formatSection } from './ui';

let verboseMode = false;

export function setVerbose(verbose: boolean): void {
  verboseMode = verbose;
}

export function isVerbose(): boolean {
  return verboseMode;
}

/**
 * Redact sensitive information
 */
function redact(value: string): string {
  return value
    .replace(/trx_[a-z]+_[a-f0-9]{64}/gi, 'trx_***')
    .replace(/\?sv=[^&\s]+(&[^&\s]+)*/g, '?[REDACTED]')
    .replace(/sig=[^&\s]+/g, 'sig=***');
}

export const logger = {
  info: (msg: string) => console.log(`  ${msg}`),
  success: (msg: string) =>
    console.log(`  ${colors.success(symbols.success)} ${msg}`),
  warn: (msg: string) =>
    console.warn(`  ${colors.warning(symbols.warning)} ${colors.warning(msg)}`),
  error: (msg: string) =>
    console.error(`  ${colors.error(symbols.error)} ${colors.error(msg)}`),

  verbose: (msg: string) =>
    verboseMode && console.log(`  ${colors.dim(redact(msg))}`),
  debug: (msg: string) =>
    verboseMode && console.log(`  ${colors.dim(`[DEBUG] ${redact(msg)}`)}`),

  section: (title: string) => console.log(formatSection(title)),
  kv: (key: string, value: string | number | boolean) =>
    console.log(formatKeyValue(key, value)),
  item: (msg: string) => console.log(`  ${colors.dim(symbols.bullet)} ${msg}`),
  blank: () => console.log(),

  redact,
};
